type PriceRule = {
    code: string;
    label: string;
    amountCents: number;
    unit: 'base' | 'per_user' | 'per_administration' | 'one_time';
    moduleId: number | null;
};

function formatEuro(cents: number): string {
    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100);
}

export function computeMonthlyCents(rules: PriceRule[], users: number, selectedModuleCodes: string[]): number {
    let total = 0;
    for (const rule of rules) {
        if (rule.unit === 'one_time') continue;
        if (rule.code === 'base') total += rule.amountCents;
        else if (rule.unit === 'per_user') total += rule.amountCents * Math.max(1, users);
        else if (rule.code.startsWith('module_') && selectedModuleCodes.includes(rule.code.replace('module_', ''))) {
            total += rule.amountCents;
        }
    }
    return total;
}

export function initCalculator(root: HTMLElement): void {
    const rules: PriceRule[] = JSON.parse(root.dataset.prices ?? '[]');
    const usersInput = root.querySelector<HTMLInputElement>('[data-calc="users"]');
    const totalEl = root.querySelector<HTMLElement>('[data-calc="total"]');
    const moduleBoxes = Array.from(root.querySelectorAll<HTMLInputElement>('[data-calc-module]'));
    const cta = document.querySelector<HTMLAnchorElement>('[data-calc-cta]');

    // Autohandel bundelt Voorraad: bij autohandel wordt voorraad verplicht meegenomen en vergrendeld.
    const autohandelBox = moduleBoxes.find((b) => b.dataset.calcModule === 'autohandel');
    const voorraadBox = moduleBoxes.find((b) => b.dataset.calcModule === 'voorraad');
    function syncBundle(): void {
        if (!autohandelBox || !voorraadBox) return;
        const bundled = autohandelBox.checked;
        const label = voorraadBox.closest('label');
        if (bundled) {
            voorraadBox.checked = true;
            voorraadBox.disabled = true;
            label?.setAttribute('data-bundled', 'autohandel');
        } else {
            voorraadBox.disabled = false;
            label?.removeAttribute('data-bundled');
        }
    }

    function recalc(): void {
        syncBundle();
        const users = Number(usersInput?.value ?? '1');
        const selected = moduleBoxes.filter((b) => b.checked).map((b) => b.dataset.calcModule ?? '');
        if (totalEl) totalEl.textContent = formatEuro(computeMonthlyCents(rules, users, selected));
        if (cta) {
            const base = cta.getAttribute('href')?.split('?')[0] ?? '/gratis-startmaand-aanvragen';
            const params = new URLSearchParams({ users: String(Math.max(1, users)) });
            if (selected.length) params.set('modules', selected.join(','));
            cta.setAttribute('href', `${base}?${params.toString()}`);
        }
    }

    usersInput?.addEventListener('input', recalc);
    moduleBoxes.forEach((b) => b.addEventListener('change', recalc));
    // Autohandel uitgevinkt: de meegebundelde voorraad ook loslaten.
    autohandelBox?.addEventListener('change', () => {
        if (autohandelBox && voorraadBox && !autohandelBox.checked) {
            voorraadBox.checked = false;
        }
        recalc();
    });
    recalc();
}
